import { useNavigate } from 'react-router-dom';
import { dailyNeeds } from '../../utils/categoryData';
import './DailyNeeds.css';

export default function DailyNeeds() {
  const navigate = useNavigate();
  return (
    <div className="daily-page">
      <div className="daily-header">
        <div className="container">
          <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
          <h1>Daily Needs</h1>
        </div>
      </div>
      <div className="container">
        <div className="daily-needs-grid">
          {dailyNeeds.map((cat, i) => (
            <div key={i} className="dn-card" onClick={() => navigate(`/categories/business?filter=${cat.name}`)}>
              <div className="dn-icon">{cat.icon}</div>
              <p>{cat.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
